export default "__VITE_ASSET__BTqRR_g3__"